"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GtmInitBrand = exports.GDPRNewGroupStatus = exports.GDPRNewGroups = exports.GDPRGroupState = exports.GDPRGroups = exports.GtmLoginType = exports.GtmLoginStatus = exports.GtmRegistrationType = exports.GtmPageType = exports.GtmInitPlatform = exports.GtmDepositType = exports.GtmLoginMethod = exports.GtmLobbyName = exports.GtmFilterEnabled = exports.GtmDataLayerVar = exports.GtmEventAction = void 0;
var GtmEventAction;
(function (GtmEventAction) {
    GtmEventAction["AccountVerificationClick"] = "AccountVerificationClick";
    GtmEventAction["AccountVerificationConfirmed"] = "AccountVerificationConfirmed";
    GtmEventAction["AccountVerificationOpen"] = "AccountVerificationOpen";
    GtmEventAction["AppDownloadBannerClicked"] = "AppDownloadBannerClicked";
    GtmEventAction["AppDownloadBannerClosed"] = "AppDownloadBannerClosed";
    GtmEventAction["AppDownloadBannerShown"] = "AppDownloadBannerShown";
    GtmEventAction["BackgroundToggle"] = "BackgroundToggle";
    GtmEventAction["BankIDOpen"] = "BankIDOpen";
    GtmEventAction["BankIDStart"] = "BankIDStart";
    GtmEventAction["BankIDVerification"] = "BankIDVerification";
    GtmEventAction["BannerClick"] = "BannerClick";
    GtmEventAction["BetConfirmed"] = "BetConfirmed";
    GtmEventAction["BetDistributionClick"] = "BetDistributionClick";
    GtmEventAction["BetFailed"] = "BetFailed";
    GtmEventAction["BetslipDetail"] = "BetslipDetail";
    GtmEventAction["BonusBackBannerClick"] = "BonusBackBannerClick";
    GtmEventAction["BonusSelection"] = "BonusSelection";
    GtmEventAction["BonusSelectionClick"] = "BonusSelectionClick";
    GtmEventAction["BonusSelectionOpen"] = "BonusSelectionOpen";
    GtmEventAction["BottomNavigationClick"] = "BottomNavigationClick";
    GtmEventAction["BrandHeaderLogo"] = "BrandHeaderLogo";
    GtmEventAction["BreadcrumbsClick"] = "BreadcrumbsClick";
    GtmEventAction["BurgerMenuClick"] = "BurgerMenuClick";
    GtmEventAction["CarouselCardClick"] = "CarouselCardClick";
    GtmEventAction["CarouselNavigationClick"] = "CarouselNavigationClick";
    GtmEventAction["CasinoFilterAdded"] = "CasinoFilterAdded";
    GtmEventAction["CasinoFilterClick"] = "CasinoFilterClick";
    GtmEventAction["CasinoFilterRemoved"] = "CasinoFilterRemoved";
    GtmEventAction["CasinoSortApplied"] = "CasinoSortApplied";
    GtmEventAction["CasinoSortByClick"] = "CasinoSortByClick";
    GtmEventAction["CasinoSortClick"] = "CasinoSortClick";
    GtmEventAction["CasinoWidgetClick"] = "CasinoWidgetClick";
    GtmEventAction["CasinoWidgetTabClick"] = "CasinoWidgetTabClick";
    GtmEventAction["ChangePasswordFailed"] = "ChangePasswordFailed";
    GtmEventAction["ChangePasswordFormOpen"] = "ChangePasswordFormOpen";
    GtmEventAction["ChangePasswordFormSubmit"] = "ChangePasswordFormSubmit";
    GtmEventAction["ChangePasswordSuccess"] = "ChangePasswordSuccess";
    GtmEventAction["ChangeRegistrationType"] = "ChangeRegistrationType";
    GtmEventAction["CloseNavigationPopup"] = "CloseNavigationPopup";
    GtmEventAction["ClosePopup"] = "ClosePopup";
    GtmEventAction["ConfirmedDeposit"] = "ConfirmedDeposit";
    GtmEventAction["ConfirmedRegistration"] = "ConfirmedRegistration";
    GtmEventAction["ConsentChange"] = "ConsentChange";
    GtmEventAction["ConsentConfirmed"] = "ConsentConfirmed";
    GtmEventAction["ConsentOpen"] = "ConsentOpen";
    GtmEventAction["ConsentSubmitted"] = "ConsentSubmitted";
    GtmEventAction["ContentLinksClick"] = "ContentLinksClick";
    GtmEventAction["CreateAccount"] = "CreateAccount";
    GtmEventAction["CreateAccountClick"] = "CreateAccountClick";
    GtmEventAction["CreateCouponSubmit"] = "CreateCouponSubmit";
    GtmEventAction["DebugBearError"] = "DebugBearError";
    GtmEventAction["DebugBearLoaded"] = "DebugBearLoaded";
    GtmEventAction["DepositLimitCalculate"] = "DepositLimitCalculate";
    GtmEventAction["DepositLimitCalculatorFieldChange"] = "DepositLimitCalculatorFieldChange";
    GtmEventAction["DepositLimitCalculatorLinkClick"] = "DepositLimitCalculatorLinkClick";
    GtmEventAction["DepositWithoutBonus"] = "DepositWithoutBonus";
    GtmEventAction["ElementClicked"] = "ElementClicked";
    GtmEventAction["ElementSeen"] = "ElementSeen";
    GtmEventAction["EngagementClick"] = "EngagementClick";
    GtmEventAction["EskimiLoaded"] = "EskimiLoaded";
    GtmEventAction["ExitIntentModalClick"] = "ExitIntentModalClick";
    GtmEventAction["ExitIntentModalDismissed"] = "ExitIntentModalDismissed";
    GtmEventAction["ExitIntentModalShow"] = "ExitIntentModalShow";
    GtmEventAction["FailedRegistration"] = "FailedRegistration";
    GtmEventAction["FavouriteGameClick"] = "FavouriteGameClick";
    GtmEventAction["FirstDeposit"] = "FirstDeposit";
    GtmEventAction["ForgottenPassword"] = "ForgottenPassword";
    GtmEventAction["ForgottenPasswordFailed"] = "ForgottenPasswordFailed";
    GtmEventAction["ForgottenPasswordSuccess"] = "ForgottenPasswordSuccess";
    GtmEventAction["FullBetHistoryClick"] = "FullBetHistoryClick";
    GtmEventAction["FundsProtectionOpen"] = "FundsProtectionOpen";
    GtmEventAction["GameBottomNavigationClick"] = "GameBottomNavigationClick";
    GtmEventAction["GameCategoryHeaderClick"] = "GameCategoryHeaderClick";
    GtmEventAction["GameFrameClick"] = "GameFrameClick";
    GtmEventAction["GamePlayedForFun"] = "GamePlayedForFun";
    GtmEventAction["GamePlayedForReal"] = "GamePlayedForReal";
    GtmEventAction["GDPRConsent"] = "GDPRConsent";
    GtmEventAction["GenericButtonClick"] = "GenericButtonClick";
    GtmEventAction["GenericFormFailed"] = "GenericFormFailed";
    GtmEventAction["GenericFormFieldChange"] = "GenericFormFieldChange";
    GtmEventAction["GenericFormOpen"] = "GenericFormOpen";
    GtmEventAction["GenericFormSubmit"] = "GenericFormSubmit";
    GtmEventAction["GenericFormSuccess"] = "GenericFormSuccess";
    GtmEventAction["GtagUpdate"] = "GtagUpdate";
    GtmEventAction["HomeVisits"] = "HomeVisits";
    GtmEventAction["InsertBonusCode"] = "InsertBonusCode";
    GtmEventAction["LeaguesSelectionChange"] = "LeaguesSelectionChange";
    GtmEventAction["LinkClick"] = "LinkClick";
    GtmEventAction["LiveEventVisit"] = "LiveEventVisit";
    GtmEventAction["LiveStreamInteraction"] = "LiveStreamInteraction";
    GtmEventAction["LoginFailed"] = "LoginFailed";
    GtmEventAction["LoginFailure"] = "LoginFailure";
    GtmEventAction["LoginFieldChange"] = "LoginFieldChange";
    GtmEventAction["LoginFormOpen"] = "LoginFormOpen";
    GtmEventAction["LoginIntention"] = "LoginIntention";
    GtmEventAction["LoginPasswordFormSubmit"] = "LoginPasswordFormSubmit";
    GtmEventAction["LoginSubmitted"] = "LoginSubmitted";
    GtmEventAction["LoginTabClick"] = "LoginTabClick";
    GtmEventAction["LoginUsernameFormSubmit"] = "LoginUsernameFormSubmit";
    GtmEventAction["MainNavigationClick"] = "MainNavigationClick";
    GtmEventAction["MarketSelectorApplied"] = "MarketSelectorApplied";
    GtmEventAction["MarketSelectorClick"] = "MarketSelectorClick";
    GtmEventAction["MitIDClose"] = "MitIDClose";
    GtmEventAction["MitIDOpen"] = "MitIDOpen";
    GtmEventAction["MultiMarketToggle"] = "MultiMarketToggle";
    GtmEventAction["MultipleGameWindow"] = "MultipleGameWindow";
    GtmEventAction["MyAccountClick"] = "MyAccountClick";
    GtmEventAction["MyBetssonPanelClick"] = "MyBetssonPanelClick";
    GtmEventAction["MyGamesClick"] = "MyGamesClick";
    GtmEventAction["MyGamesViewAllClick"] = "MyGamesViewAllClick";
    GtmEventAction["NemIDClose"] = "NemIDClose";
    GtmEventAction["NemIDOpen"] = "NemIDOpen";
    GtmEventAction["NotSwedishRegClick"] = "NotSwedishRegClick";
    GtmEventAction["OddsUpdateAction"] = "OddsUpdateAction";
    GtmEventAction["OddsUpdateFailed"] = "OddsUpdateFailed";
    GtmEventAction["OMSClick"] = "OMSClick";
    GtmEventAction["OpenAccountWidget"] = "OpenAccountWidget";
    GtmEventAction["OpenDepPage"] = "OpenDepPage";
    GtmEventAction["OpenMobileBankID"] = "OpenMobileBankID";
    GtmEventAction["OpenPopupClick"] = "OpenPopupClick";
    GtmEventAction["OpenRegPage"] = "OpenRegPage";
    GtmEventAction["optimize_activate"] = "optimize.activate";
    GtmEventAction["OverlayMessage"] = "OverlayMessage";
    GtmEventAction["PaymentAmountChange"] = "PaymentAmountChange";
    GtmEventAction["PaymentFailed"] = "PaymentFailed";
    GtmEventAction["PaymentFieldChange"] = "PaymentFieldChange";
    GtmEventAction["PaymentProviderPopUp"] = "PaymentProviderPopUp";
    GtmEventAction["PaymentProviderWindowOpen"] = "PaymentProviderWindowOpen";
    GtmEventAction["PaymentsConnectionTiming"] = "PaymentsConnectionTiming";
    GtmEventAction["PaymentScreenClose"] = "PaymentScreenClose";
    GtmEventAction["PaymentSelectionChange"] = "PaymentSelectionChange";
    GtmEventAction["PaymentSelectionSubmit"] = "PaymentSelectionSubmit";
    GtmEventAction["PaymentsInitPolling"] = "PaymentsInitPolling";
    GtmEventAction["PaymentsPlatformError"] = "PaymentsPlatformError";
    GtmEventAction["PaymentValidationFailed"] = "PaymentValidationFailed";
    GtmEventAction["PinClick"] = "PinClick";
    GtmEventAction["PlaceBetClick"] = "PlaceBetClick";
    GtmEventAction["PokerClick"] = "PokerClick";
    GtmEventAction["PokerPromotionsClick"] = "PokerPromotionsClick";
    GtmEventAction["PokerSideGames"] = "PokerSideGames";
    GtmEventAction["PokerSideGamesNavigation"] = "PokerSideGamesNavigation";
    GtmEventAction["ProductFavouriteClick"] = "ProductFavouriteClick";
    GtmEventAction["ProductFilterApplied"] = "ProductFilterApplied";
    GtmEventAction["ProductFilterClick"] = "ProductFilterClick";
    GtmEventAction["ProductNavigationClick"] = "ProductNavigationClick";
    GtmEventAction["ProductSortApplied"] = "ProductSortApplied";
    GtmEventAction["ProductSortClick"] = "ProductSortClick";
    GtmEventAction["PromotionBannerClick"] = "PromotionBannerClick";
    GtmEventAction["ProviderPopupBlocked"] = "ProviderPopupBlocked";
    GtmEventAction["QuickLinksScroller"] = "QuickLinksScroller";
    GtmEventAction["RegIntention"] = "RegIntention";
    GtmEventAction["RegistrationActivity"] = "RegistrationActivity";
    GtmEventAction["RegistrationClicks"] = "RegistrationClicks";
    GtmEventAction["RegistrationFailedNextStepClick"] = "RegistrationFailedNextStepClick";
    GtmEventAction["RegistrationFieldChange"] = "RegistrationFieldChange";
    GtmEventAction["RegistrationFieldChange2"] = "RegistrationFieldChange2";
    GtmEventAction["RegistrationFieldError"] = "RegistrationFieldError";
    GtmEventAction["RegistrationLoginClick"] = "RegistrationLoginClick";
    GtmEventAction["RegistrationPostStepClick"] = "RegistrationPostStepClick";
    GtmEventAction["RegistrationSubmitted"] = "RegistrationSubmitted";
    GtmEventAction["ResetPasswordFailed"] = "ResetPasswordFailed";
    GtmEventAction["ResetPasswordFormOpen"] = "ResetPasswordFormOpen";
    GtmEventAction["ResetPasswordFormSubmit"] = "ResetPasswordFormSubmit";
    GtmEventAction["ResetPasswordSuccess"] = "ResetPasswordSuccess";
    GtmEventAction["SearchCasino"] = "SearchCasino";
    GtmEventAction["SearchClick"] = "SearchClick";
    GtmEventAction["SearchGameCategoryClick"] = "SearchGameCategoryClick";
    GtmEventAction["SearchLinkClick"] = "SearchLinkClick";
    GtmEventAction["SetNewPassword"] = "SetNewPassword";
    GtmEventAction["SettingsClick"] = "SettingsClick";
    GtmEventAction["SGAHeaderLogo"] = "SGAHeaderLogo";
    GtmEventAction["SkipPassword"] = "SkipPassword";
    GtmEventAction["SmartBannerClick"] = "SmartBannerClick";
    GtmEventAction["SmartIDFormClick"] = "SmartIDFormClick";
    GtmEventAction["SmartIDLoginVerificationOpen"] = "SmartIDLoginVerificationOpen";
    GtmEventAction["SmartIDRegVerificationErrorClick"] = "SmartIDRegVerificationErrorClick";
    GtmEventAction["SmartIDRegVerificationFailed"] = "SmartIDRegVerificationFailed";
    GtmEventAction["SmartIDRegVerificationOpen"] = "SmartIDRegVerificationOpen";
    GtmEventAction["SmartIDRegVerificationSuccess"] = "SmartIDRegVerificationSuccess";
    GtmEventAction["SportsbookBannerClick"] = "SportsbookBannerClick";
    GtmEventAction["SportsbookDropdownClick"] = "SportsbookDropdownClick";
    GtmEventAction["SportsBookNavigationClick"] = "SportsBookNavigationClick";
    GtmEventAction["SportsbookPreferenceChange"] = "SportsbookPreferenceChange";
    GtmEventAction["SportsbookSearchClick"] = "SportsbookSearchClick";
    GtmEventAction["SportsbookSubCategoryClick"] = "SportsbookSubCategoryClick";
    GtmEventAction["SportsbookWidgetClick"] = "SportsbookWidgetClick";
    GtmEventAction["StatsClick"] = "StatsClick";
    GtmEventAction["SuccessfulGameAdded"] = "SuccessfulGameAdded";
    GtmEventAction["SuccessfulLogin"] = "SuccessfulLogin";
    GtmEventAction["TiledFilterClick"] = "TiledFilterClick";
    GtmEventAction["TopBurgerMenuClick"] = "TopBurgerMenuClick";
    GtmEventAction["TopNavigationClick"] = "TopNavigationClick";
    GtmEventAction["TournamentsClick"] = "TournamentsClick";
    GtmEventAction["TournamentsFailed"] = "TournamentsFailed";
    GtmEventAction["TournamentsGamesNavigation"] = "TournamentsGamesNavigation";
    GtmEventAction["TournamentsNavigation"] = "TournamentsNavigation";
    GtmEventAction["TournamentsOpen"] = "TournamentsOpen";
    GtmEventAction["TournamentsOptInFailed"] = "TournamentsOptInFailed";
    GtmEventAction["TournamentsOptInSuccess"] = "TournamentsOptInSuccess";
    GtmEventAction["TournamentsTabNavigation"] = "TournamentsTabNavigation";
    GtmEventAction["TrustlyClose"] = "TrustlyClose";
    GtmEventAction["TrustlyOpen"] = "TrustlyOpen";
    GtmEventAction["TwoFADisableConfirmationCancel"] = "TwoFADisableConfirmationCancel";
    GtmEventAction["TwoFADisableConfirmationOpen"] = "TwoFADisableConfirmationOpen";
    GtmEventAction["TwoFADisableConfirmationTurnoff"] = "TwoFADisableConfirmationTurnoff";
    GtmEventAction["TwoFALoginPasswordCancel"] = "TwoFALoginPasswordCancel";
    GtmEventAction["TwoFALoginPasswordFailed"] = "TwoFALoginPasswordFailed";
    GtmEventAction["TwoFALoginPasswordSubmit"] = "TwoFALoginPasswordSubmit";
    GtmEventAction["TwoFALoginPasswordSuccess"] = "TwoFALoginPasswordSuccess";
    GtmEventAction["TwoFAMobileSMSAuthCancel"] = "TwoFAMobileSMSAuthCancel";
    GtmEventAction["TwoFAMobileSMSAuthChange"] = "TwoFAMobileSMSAuthChange";
    GtmEventAction["TwoFAMobileSMSAuthContinue"] = "TwoFAMobileSMSAuthContinue";
    GtmEventAction["TwoFAMobileSMSAuthOpen"] = "TwoFAMobileSMSAuthOpen";
    GtmEventAction["TwoFANotificationClick"] = "TwoFANotificationClick";
    GtmEventAction["TwoFANotificationOpen"] = "TwoFANotificationOpen";
    GtmEventAction["TwoFASetupClick"] = "TwoFASetupClick";
    GtmEventAction["TwoFASetupDisabled"] = "TwoFASetupDisabled";
    GtmEventAction["TwoFASetupOpen"] = "TwoFASetupOpen";
    GtmEventAction["TwoFASetupSuccess"] = "TwoFASetupSuccess";
    GtmEventAction["TwoFASetupTurnOffClick"] = "TwoFASetupTurnOffClick";
    GtmEventAction["TwoFASMSVerificationCode"] = "TwoFASMSVerificationCode";
    GtmEventAction["VerificationBarShown"] = "VerificationBarShown";
    GtmEventAction["VerificationStartClick"] = "VerificationStartClick";
    GtmEventAction["VerifiedRegistration"] = "VerifiedRegistration";
    GtmEventAction["VerifyAccountClick"] = "VerifyAccountClick";
    GtmEventAction["VerifyAccountOpen"] = "VerifyAccountOpen";
    GtmEventAction["ViewAllHeaderClick"] = "ViewAllHeaderClick";
    GtmEventAction["ViewOtherPaymentMethods"] = "ViewOtherPaymentMethods";
    GtmEventAction["VirtualPageView"] = "VirtualPageView";
    GtmEventAction["WebsiteToggle"] = "WebsiteToggle";
    GtmEventAction["WelcomeMessageClick"] = "WelcomeMessageClick";
    GtmEventAction["WelcomeMessageOpen"] = "WelcomeMessageOpen";
    GtmEventAction["Withdrawal"] = "Withdrawal";
})(GtmEventAction = exports.GtmEventAction || (exports.GtmEventAction = {}));
;
var GtmDataLayerVar;
(function (GtmDataLayerVar) {
    GtmDataLayerVar["Action"] = "Action";
    GtmDataLayerVar["ActiveGameFrames"] = "ActiveGameFrames";
    GtmDataLayerVar["ActivityName"] = "ActivityName";
    GtmDataLayerVar["Age"] = "Age";
    GtmDataLayerVar["Amount"] = "Amount";
    GtmDataLayerVar["Area"] = "Area";
    GtmDataLayerVar["BackgroundState"] = "BackgroundState";
    GtmDataLayerVar["BalanceAmount"] = "BalanceAmount";
    GtmDataLayerVar["BannerName"] = "BannerName";
    GtmDataLayerVar["BannerPosition"] = "BannerPosition";
    GtmDataLayerVar["BannerTitle"] = "BannerTitle";
    GtmDataLayerVar["BetMarket"] = "BetMarket";
    GtmDataLayerVar["BetType"] = "BetType";
    GtmDataLayerVar["Bonus_EventPhase"] = "Bonus_EventPhase";
    GtmDataLayerVar["Bonus_ID"] = "Bonus_ID";
    GtmDataLayerVar["BonusTitle"] = "BonusTitle";
    GtmDataLayerVar["BonusType"] = "BonusType";
    GtmDataLayerVar["CampaignClicked"] = "CampaignClicked";
    GtmDataLayerVar["CardClicked"] = "CardClicked";
    GtmDataLayerVar["CategoryClicked"] = "CategoryClicked";
    GtmDataLayerVar["CategoryID"] = "CategoryID";
    GtmDataLayerVar["CategoryName"] = "CategoryName";
    GtmDataLayerVar["CD_ClickType"] = "CD_ClickType";
    GtmDataLayerVar["CD_GRE_Selection"] = "CD_GRE_Selection";
    GtmDataLayerVar["CD_Position"] = "CD_Position";
    GtmDataLayerVar["ChildOrigin"] = "ChildOrigin";
    GtmDataLayerVar["ClickArea"] = "ClickArea";
    GtmDataLayerVar["ClickUrl"] = "ClickUrl";
    GtmDataLayerVar["CompetitionID"] = "CompetitionID";
    GtmDataLayerVar["CompetitionName"] = "CompetitionName";
    GtmDataLayerVar["ConnectionStatus"] = "ConnectionStatus";
    GtmDataLayerVar["ConnectionTiming"] = "ConnectionTiming";
    GtmDataLayerVar["ConsentFields"] = "ConsentFields";
    GtmDataLayerVar["Country"] = "Country";
    GtmDataLayerVar["CouponID"] = "CouponID";
    GtmDataLayerVar["cs_lobby_faq_category"] = "cs_lobby_faq_category";
    GtmDataLayerVar["cs_lobby_faq_id"] = "cs_lobby_faq_id";
    GtmDataLayerVar["Currency"] = "Currency";
    GtmDataLayerVar["CurrentTargetUrl"] = "CurrentTargetUrl";
    GtmDataLayerVar["custom_timerEventNumber"] = "custom.timerEventNumber";
    GtmDataLayerVar["DepositLimitAmount"] = "DepositLimitAmount";
    GtmDataLayerVar["DepositType"] = "DepositType";
    GtmDataLayerVar["Destination"] = "Destination";
    GtmDataLayerVar["Direction"] = "Direction";
    GtmDataLayerVar["ecommerce_items"] = "ecommerce.items";
    GtmDataLayerVar["ElementID"] = "ElementID";
    GtmDataLayerVar["ElementName"] = "ElementName";
    GtmDataLayerVar["Error"] = "Error";
    GtmDataLayerVar["EventID"] = "EventID";
    GtmDataLayerVar["EventLabel"] = "EventLabel";
    GtmDataLayerVar["EventName"] = "EventName";
    GtmDataLayerVar["EventPhase"] = "EventPhase";
    GtmDataLayerVar["expId"] = "expId";
    GtmDataLayerVar["expVar"] = "expVar";
    GtmDataLayerVar["FavArea"] = "FavArea";
    GtmDataLayerVar["FieldCount"] = "FieldCount";
    GtmDataLayerVar["FieldName"] = "FieldName";
    GtmDataLayerVar["FilterEnabled"] = "FilterEnabled";
    GtmDataLayerVar["FilterItem"] = "FilterItem";
    GtmDataLayerVar["FilterItemBucket"] = "FilterItemBucket";
    GtmDataLayerVar["FormName"] = "FormName";
    GtmDataLayerVar["GAEventName"] = "GAEventName";
    GtmDataLayerVar["GameCategory"] = "GameCategory";
    GtmDataLayerVar["GameCollectionPosition"] = "GameCollectionPosition";
    GtmDataLayerVar["GameName"] = "GameName";
    GtmDataLayerVar["GameProvider"] = "GameProvider";
    GtmDataLayerVar["gdpr_functional_enabled"] = "gdpr_functional_enabled";
    GtmDataLayerVar["gdpr_performance_enabled"] = "gdpr_performance_enabled";
    GtmDataLayerVar["gdpr_targeting_enabled"] = "gdpr_targeting_enabled";
    GtmDataLayerVar["GDPRFunctionalAccepted"] = "GDPRFunctionalAccepted";
    GtmDataLayerVar["GDPRPerformanceAccepted"] = "GDPRPerformanceAccepted";
    GtmDataLayerVar["GDPRTargetingAccepted"] = "GDPRTargetingAccepted";
    GtmDataLayerVar["gtm_init_brand"] = "gtm_init_brand";
    GtmDataLayerVar["gtm_init_environment"] = "gtm_init_environment";
    GtmDataLayerVar["gtm_init_platform"] = "gtm_init_platform";
    GtmDataLayerVar["gtm_init_traffic"] = "gtm_init_traffic";
    GtmDataLayerVar["gtm_is_cookie_consent_disabled"] = "gtm_is_cookie_consent_disabled";
    GtmDataLayerVar["gtm_static"] = "gtm_static";
    GtmDataLayerVar["GUID"] = "GUID";
    GtmDataLayerVar["HashedEmail"] = "HashedEmail";
    GtmDataLayerVar["IDProof"] = "IDProof";
    GtmDataLayerVar["ItemClicked"] = "ItemClicked";
    GtmDataLayerVar["Jurisdiction"] = "Jurisdiction";
    GtmDataLayerVar["KYCStatus"] = "KYCStatus";
    GtmDataLayerVar["Label"] = "Label";
    GtmDataLayerVar["Language"] = "Language";
    GtmDataLayerVar["Level"] = "Level";
    GtmDataLayerVar["LiveStreamAction"] = "LiveStreamAction";
    GtmDataLayerVar["Lobby"] = "Lobby";
    GtmDataLayerVar["LobbyName"] = "LobbyName";
    GtmDataLayerVar["Location"] = "Location";
    GtmDataLayerVar["LoginMethod"] = "LoginMethod";
    GtmDataLayerVar["LoginStatus"] = "LoginStatus";
    GtmDataLayerVar["LoginType"] = "LoginType";
    GtmDataLayerVar["MarketTemplateID"] = "MarketTemplateID";
    GtmDataLayerVar["Method"] = "Method";
    GtmDataLayerVar["Native_App_Name"] = "Native_App_Name";
    GtmDataLayerVar["Native_App_Version"] = "Native_App_Version";
    GtmDataLayerVar["OMStitle"] = "OMStitle";
    GtmDataLayerVar["pageId"] = "pageId";
    GtmDataLayerVar["PageType"] = "PageType";
    GtmDataLayerVar["PageView_Bucket"] = "PageView_Bucket";
    GtmDataLayerVar["PartnerID"] = "PartnerID";
    GtmDataLayerVar["PaymentFlowType"] = "PaymentFlowType";
    GtmDataLayerVar["PlatformName"] = "PlatformName";
    GtmDataLayerVar["Product_Theme"] = "Product_Theme";
    GtmDataLayerVar["ProductName"] = "ProductName";
    GtmDataLayerVar["PromotionName"] = "PromotionName";
    GtmDataLayerVar["PromotionType"] = "PromotionType";
    GtmDataLayerVar["Provider"] = "Provider";
    GtmDataLayerVar["providers"] = "providers";
    GtmDataLayerVar["PublicPaymentId"] = "PublicPaymentId";
    GtmDataLayerVar["RegistrationCountry"] = "RegistrationCountry";
    GtmDataLayerVar["RegistrationMethod"] = "RegistrationMethod";
    GtmDataLayerVar["RegistrationProduct"] = "RegistrationProduct";
    GtmDataLayerVar["RegistrationStep"] = "RegistrationStep";
    GtmDataLayerVar["RegistrationType"] = "RegistrationType";
    GtmDataLayerVar["ReleaseName"] = "ReleaseName";
    GtmDataLayerVar["ReleaseVersion"] = "ReleaseVersion";
    GtmDataLayerVar["RememberStakeFlag"] = "RememberStakeFlag";
    GtmDataLayerVar["ResidenceProof"] = "ResidenceProof";
    GtmDataLayerVar["ResponseMessage"] = "ResponseMessage";
    GtmDataLayerVar["searchterm"] = "searchterm";
    GtmDataLayerVar["SectionName"] = "SectionName";
    GtmDataLayerVar["Sex"] = "Sex";
    GtmDataLayerVar["SiteVersion"] = "SiteVersion";
    GtmDataLayerVar["Slide_Number"] = "Slide_Number";
    GtmDataLayerVar["SmartBannerClickType"] = "SmartBannerClickType";
    GtmDataLayerVar["Sportsbook_EventPhase"] = "Sportsbook_EventPhase";
    GtmDataLayerVar["Sportsbook_MarketName"] = "Sportsbook_MarketName";
    GtmDataLayerVar["StakeForReview"] = "StakeForReview";
    GtmDataLayerVar["StartType"] = "StartType";
    GtmDataLayerVar["Status"] = "Status";
    GtmDataLayerVar["SubArea"] = "SubArea";
    GtmDataLayerVar["TabName"] = "TabName";
    GtmDataLayerVar["tags"] = "tags";
    GtmDataLayerVar["Target_Url"] = "Target_Url";
    GtmDataLayerVar["ToggleField"] = "ToggleField";
    GtmDataLayerVar["Topic"] = "Topic";
    GtmDataLayerVar["TotalStake"] = "TotalStake";
    GtmDataLayerVar["TournamentID"] = "TournamentID";
    GtmDataLayerVar["TournamentType"] = "TournamentType";
    GtmDataLayerVar["TriggerType"] = "TriggerType";
    GtmDataLayerVar["TypeSearchResults"] = "TypeSearchResults";
    GtmDataLayerVar["UISelectedAmount"] = "UISelectedAmount";
    GtmDataLayerVar["UISelectedCurrency"] = "UISelectedCurrency";
    GtmDataLayerVar["ViewType"] = "ViewType";
    GtmDataLayerVar["VirtualTitle"] = "VirtualTitle";
    GtmDataLayerVar["VirtualUrl"] = "VirtualUrl";
    GtmDataLayerVar["WidgetEvent"] = "WidgetEvent";
    GtmDataLayerVar["WidgetName"] = "WidgetName";
})(GtmDataLayerVar = exports.GtmDataLayerVar || (exports.GtmDataLayerVar = {}));
;
var GtmFilterEnabled;
(function (GtmFilterEnabled) {
    GtmFilterEnabled["True"] = "true";
    GtmFilterEnabled["False"] = "false";
})(GtmFilterEnabled = exports.GtmFilterEnabled || (exports.GtmFilterEnabled = {}));
;
var GtmLobbyName;
(function (GtmLobbyName) {
    GtmLobbyName["Admin"] = "ADMIN";
    GtmLobbyName["ActivateAccount"] = "ACTIVATE_ACCOUNT";
    GtmLobbyName["Blog"] = "BLOG";
    GtmLobbyName["BetGames"] = "BET_GAMES";
    GtmLobbyName["Bingo"] = "BINGO";
    GtmLobbyName["Bonuses"] = "BONUSES";
    GtmLobbyName["Casino"] = "CASINO";
    GtmLobbyName["Content"] = "CONTENT";
    GtmLobbyName["CookiePolicy"] = "COOKIE_POLICY";
    GtmLobbyName["CustomerService"] = "CUSTOMER_SERVICE";
    GtmLobbyName["Deposit"] = "DEPOSIT";
    GtmLobbyName["DepositCalculator"] = "DEPOSIT_CALCULATOR";
    GtmLobbyName["FantasyGames"] = "FANTASY_GAMES";
    GtmLobbyName["ForgottenPassword"] = "FORGOTTEN_PASSWORD";
    GtmLobbyName["GameRules"] = "GAME_RULES";
    GtmLobbyName["Generic"] = "GENERIC";
    GtmLobbyName["Home"] = "HOME";
    GtmLobbyName["HorseRacing"] = "HORSE_RACING";
    GtmLobbyName["Info"] = "INFO";
    GtmLobbyName["InternalError"] = "INTERNAL_ERROR";
    GtmLobbyName["Jackpots"] = "JACKPOTS";
    GtmLobbyName["KycBar"] = "KYC_BAR";
    GtmLobbyName["LiveCasino"] = "LIVE_CASINO";
    GtmLobbyName["LiveSportsbook"] = "LIVE_SPORTSBOOK";
    GtmLobbyName["Login"] = "LOGIN";
    GtmLobbyName["MarketSelector"] = "MARKET_SELECTOR";
    GtmLobbyName["MyAccount"] = "MY_ACCOUNT";
    GtmLobbyName["Oms"] = "OMS";
    GtmLobbyName["PageNotFound"] = "PAGE_NOT_FOUND";
    GtmLobbyName["PersonalData"] = "PERSONAL_DATA";
    GtmLobbyName["Poker"] = "POKER";
    GtmLobbyName["PrivacyPolicy"] = "PRIVACY_POLICY";
    GtmLobbyName["Promotions"] = "PROMOTIONS";
    GtmLobbyName["PromotionsBingo"] = "PROMOTIONS_BINGO";
    GtmLobbyName["PromotionsCasino"] = "PROMOTIONS_CASINO";
    GtmLobbyName["PromotionsLiveCasino"] = "PROMOTIONS_LIVE_CASINO";
    GtmLobbyName["PromotionsLiveSportsbook"] = "PROMOTIONS_LIVE_SPORTSBOOK";
    GtmLobbyName["PromotionsMixed"] = "PROMOTIONS_MIXED";
    GtmLobbyName["PromotionsPoker"] = "PROMOTIONS_POKER";
    GtmLobbyName["PromotionsSportsbook"] = "PROMOTIONS_SPORTSBOOK";
    GtmLobbyName["Register"] = "REGISTER";
    GtmLobbyName["ResetPassword"] = "RESET_PASSWORD";
    GtmLobbyName["ResponsibleGaming"] = "RESPONSIBLE_GAMING";
    GtmLobbyName["Sportsbook"] = "SPORTSBOOK";
    GtmLobbyName["SportsbookRules"] = "SPORTSBOOK_RULES";
    GtmLobbyName["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
    GtmLobbyName["TwoFA"] = "TWOFA";
    GtmLobbyName["VerifyPopup"] = "VERIFY_POPUP";
    GtmLobbyName["VirtualSports"] = "VIRTUAL_SPORTS";
    GtmLobbyName["WelcomeBonus"] = "WELCOME_BONUS";
    GtmLobbyName["Withdraw"] = "WITHDRAW";
})(GtmLobbyName = exports.GtmLobbyName || (exports.GtmLobbyName = {}));
;
var GtmLoginMethod;
(function (GtmLoginMethod) {
    GtmLoginMethod["BankId"] = "BankID";
    GtmLoginMethod["Credentials"] = "Credentials";
    GtmLoginMethod["Facebook"] = "Facebook";
    GtmLoginMethod["FaceID"] = "FaceID";
    GtmLoginMethod["Google"] = "Google";
    GtmLoginMethod["MobileID"] = "MobileID";
    GtmLoginMethod["MitID"] = "MitID";
    GtmLoginMethod["NemId"] = "NemID";
    GtmLoginMethod["OTP"] = "OTP";
    GtmLoginMethod["SmartID"] = "SmartID";
    GtmLoginMethod["Trustly"] = "Trustly";
})(GtmLoginMethod = exports.GtmLoginMethod || (exports.GtmLoginMethod = {}));
;
var GtmDepositType;
(function (GtmDepositType) {
    GtmDepositType["GameFrame"] = "GameFrame";
    GtmDepositType["Normal"] = "Normal";
    GtmDepositType["QuickDeposit"] = "QuickDeposit";
})(GtmDepositType = exports.GtmDepositType || (exports.GtmDepositType = {}));
;
var GtmInitPlatform;
(function (GtmInitPlatform) {
    GtmInitPlatform["Desktop"] = "desktop";
    GtmInitPlatform["Mobile"] = "mobile";
    GtmInitPlatform["Native"] = "native";
    GtmInitPlatform["Tablet"] = "tablet";
})(GtmInitPlatform = exports.GtmInitPlatform || (exports.GtmInitPlatform = {}));
;
var GtmPageType;
(function (GtmPageType) {
    GtmPageType["BannerFlow"] = "BannerFlow";
    GtmPageType["Brand"] = "Brand";
    GtmPageType["Froyo"] = "Froyo";
    GtmPageType["Echo"] = "Echo";
    GtmPageType["Blog"] = "Blog";
})(GtmPageType = exports.GtmPageType || (exports.GtmPageType = {}));
;
var GtmRegistrationType;
(function (GtmRegistrationType) {
    GtmRegistrationType["Cgl"] = "CGL";
    GtmRegistrationType["Dga"] = "DGA";
    GtmRegistrationType["Georgia"] = "Georgia";
    GtmRegistrationType["Iaui"] = "IAUI";
    GtmRegistrationType["Iplyc"] = "IPLYC";
    GtmRegistrationType["Hgc"] = "HGC";
    GtmRegistrationType["Lotba"] = "LOTBA";
    GtmRegistrationType["Mga"] = "MGA";
    GtmRegistrationType["Mta"] = "Mta";
    GtmRegistrationType["Sga"] = "SGA";
    GtmRegistrationType["SmartID"] = "SmartID";
    GtmRegistrationType["Swish"] = "SWISH";
    GtmRegistrationType["Trustly"] = "Trustly";
    GtmRegistrationType["Ukgc"] = "UKGC";
    GtmRegistrationType["MobileID"] = "MobileID";
    GtmRegistrationType["Reda"] = "Reda";
    GtmRegistrationType["Regular"] = "Regular";
})(GtmRegistrationType = exports.GtmRegistrationType || (exports.GtmRegistrationType = {}));
;
var GtmLoginStatus;
(function (GtmLoginStatus) {
    GtmLoginStatus["LoggedIn"] = "LoggedIn";
    GtmLoginStatus["LoggedOut"] = "LoggedOut";
})(GtmLoginStatus = exports.GtmLoginStatus || (exports.GtmLoginStatus = {}));
var GtmLoginType;
(function (GtmLoginType) {
    GtmLoginType["FirstLogin"] = "FirstLogin";
    GtmLoginType["LoggedInExisting"] = "LoggedInExisting";
})(GtmLoginType = exports.GtmLoginType || (exports.GtmLoginType = {}));
var GDPRGroups;
(function (GDPRGroups) {
    GDPRGroups["Targeting"] = "gdpr_targeting_enabled";
    GDPRGroups["Performance"] = "gdpr_performance_enabled";
    GDPRGroups["Functional"] = "gdpr_functional_enabled";
})(GDPRGroups = exports.GDPRGroups || (exports.GDPRGroups = {}));
var GDPRGroupState;
(function (GDPRGroupState) {
    GDPRGroupState["Enabled"] = "1";
    GDPRGroupState["Disabled"] = "0";
})(GDPRGroupState = exports.GDPRGroupState || (exports.GDPRGroupState = {}));
var GDPRNewGroups;
(function (GDPRNewGroups) {
    GDPRNewGroups["NewTargeting"] = "GDPRTargetingAccepted";
    GDPRNewGroups["NewPerformance"] = "GDPRPerformanceAccepted";
    GDPRNewGroups["NewFunctional"] = "GDPRFunctionalAccepted";
})(GDPRNewGroups = exports.GDPRNewGroups || (exports.GDPRNewGroups = {}));
var GDPRNewGroupStatus;
(function (GDPRNewGroupStatus) {
    GDPRNewGroupStatus["EnableNow"] = "1";
    GDPRNewGroupStatus["DoNothing"] = "0";
})(GDPRNewGroupStatus = exports.GDPRNewGroupStatus || (exports.GDPRNewGroupStatus = {}));
var GtmInitBrand;
(function (GtmInitBrand) {
    GtmInitBrand["AlohaShark"] = "alohashark";
    GtmInitBrand["ArcticBet"] = "arcticbet";
    GtmInitBrand["B10"] = "b10";
    GtmInitBrand["Bets10"] = "bets10";
    GtmInitBrand["Betsafe"] = "betsafe";
    GtmInitBrand["BetsafeDE"] = "betsafede";
    GtmInitBrand["BetsafeEstonia"] = "betsafeestonia";
    GtmInitBrand["BetsafeLatvia"] = "betsafelatvia";
    GtmInitBrand["BetsafePE"] = "betsafepe";
    GtmInitBrand["BetSmith"] = "betsmith";
    GtmInitBrand["BetSolid"] = "betsolid";
    GtmInitBrand["Betsson"] = "betsson";
    GtmInitBrand["BetssonArba"] = "betssonarba";
    GtmInitBrand["BetssonArbaCity"] = "betssonarbacity";
    GtmInitBrand["BetssonArcb"] = "betssonarcb";
    GtmInitBrand["BetssonArgentina"] = "betssonargentina";
    GtmInitBrand["BetssonBE"] = "betssonbe";
    GtmInitBrand["BetssonBR"] = "betssonbr";
    GtmInitBrand["BetssonCO"] = "betssonco";
    GtmInitBrand["BetssonCZ"] = "betssoncz";
    GtmInitBrand["BetssonPE"] = "betssonpe";
    GtmInitBrand["BetssonGR"] = "betssongr";
    GtmInitBrand["BetssonDE"] = "betssonde";
    GtmInitBrand["BetssonES"] = "betssones";
    GtmInitBrand["BetssonMX"] = "betssonmx";
    GtmInitBrand["BetssonNL"] = "betssonnl";
    GtmInitBrand["BetssonPY"] = "betssonpy";
    GtmInitBrand["CasinoDK"] = "casinodk";
    GtmInitBrand["CasinoEuro"] = "casinoeuro";
    GtmInitBrand["CasinoMaxi"] = "casinomaxi";
    GtmInitBrand["CasinoMetropol"] = "casinometropol";
    GtmInitBrand["Casinowinner"] = "casinowinner";
    GtmInitBrand["EuroCasino"] = "eurocasino";
    GtmInitBrand["EuropeBet"] = "europebet";
    GtmInitBrand["JackOne"] = "jackone";
    GtmInitBrand["KroonCasino"] = "krooncasino";
    GtmInitBrand["MobilBahis"] = "mobilbahis";
    GtmInitBrand["NordicBet"] = "nordicbet";
    GtmInitBrand["NordicBetDK"] = "nordicbetdk";
    GtmInitBrand["NorgesAutomaten"] = "norgesautomaten";
    GtmInitBrand["OranjeCasino"] = "oranjecasino";
    GtmInitBrand["StarCasino"] = "starcasino";
    GtmInitBrand["SverigeAutomaten"] = "sverigeautomaten";
    GtmInitBrand["SuomiArvat"] = "suomiarvat";
})(GtmInitBrand = exports.GtmInitBrand || (exports.GtmInitBrand = {}));
